import { render, staticRenderFns } from "./BookingLogsCreateModal.vue?vue&type=template&id=b8ca3100&"
import script from "./BookingLogsCreateModal.vue?vue&type=script&lang=js&"
export * from "./BookingLogsCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./BookingLogsCreateModal.vue?vue&type=style&index=0&id=b8ca3100&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports